const formatNumberWithCommas = (number) => {
  let fixedNumber;

  if (typeof number !== "number") {
    fixedNumber = (+number).toFixed(2);
  } else {
    fixedNumber = number.toFixed(2);
  }

  const [integerPart, decimalPart] = fixedNumber.split(".");
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formattedNumber = decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;

  return formattedNumber;
};

export default formatNumberWithCommas;
